import { yupObject, yupString } from 'shared/utils/YupUtils';
import { z } from 'zod';

export const loadboardNotificationMessageYupSchema = yupObject({
  body: yupString(),
  subject: yupString(),
  load_guid: yupString(),
});

export const loadboardNotificationMessageSchema = z.object({
  body: z
    .string()
    .nullish()
    .transform((value) => value ?? ''),
  subject: z
    .string()
    .nullish()
    .transform((value) => value ?? ''),
  load_guid: z
    .string()
    .nullish()
    .transform((value) => value ?? ''),
});
